import { useGameStore } from "@/store/gameStore";
import {
  requiredDiscardCount,
  buildDiscardAction,
} from "@/engine/LegalActions";

export default function ActionBar() {
  const state = useGameStore((s) => s.state);
  const humanId = useGameStore((s) => s.humanPlayerId);
  const dispatch = useGameStore((s) => s.dispatch);
  const pendingDiscardUids = useGameStore((s) => s.pendingDiscardUids);

  if (!state) return null;
  if (state.phase === "game-over") return null;

  const cur = state.players[state.currentPlayerIdx];
  const isHumanTurn = cur.id === humanId;

  if (!isHumanTurn) {
    return (
      <div className="action-bar">
        <span className="action-bar__wait">
          等待 {cur.hero.name} 行动中...
        </span>
      </div>
    );
  }

  if (state.phase === "turn-end") {
    return (
      <div className="action-bar">
        <button
          className="action-btn action-btn--primary"
          onClick={() => dispatch({ type: "begin-turn" })}
        >
          开始回合
        </button>
      </div>
    );
  }

  if (state.phase === "draw") {
    return (
      <div className="action-bar">
        <button
          className="action-btn action-btn--primary"
          onClick={() => dispatch({ type: "draw" })}
        >
          摸牌（摸2张）
        </button>
      </div>
    );
  }

  if (state.phase === "play") {
    return (
      <div className="action-bar">
        <span className="action-bar__hint">点击高亮卡牌出牌</span>
        <button
          className="action-btn"
          onClick={() => dispatch({ type: "end-turn" })}
        >
          结束回合
        </button>
      </div>
    );
  }

  if (state.phase === "discard") {
    const need = requiredDiscardCount(cur);
    // 仅统计手牌中真实存在的已选 uid（防御跨阶段残留的旧 uid）
    const validUids = pendingDiscardUids.filter((uid) =>
      cur.hand.some((c) => c.uid === uid)
    );
    const have = validUids.length;
    // 已弃牌完成（need=0）→ 显示结束回合按钮
    if (need === 0) {
      return (
        <div className="action-bar">
          <button
            className="action-btn action-btn--primary"
            onClick={() => dispatch({ type: "end-turn" })}
          >
            结束回合
          </button>
        </div>
      );
    }
    const enabled = have === need;
    return (
      <div className="action-bar">
        <span className="action-bar__hint">
          弃牌：选 {need} 张（已选 {have}）
        </span>
        <button
          className="action-btn action-btn--primary"
          disabled={!enabled}
          onClick={() => dispatch(buildDiscardAction(validUids))}
        >
          确认弃牌
        </button>
      </div>
    );
  }

  return null;
}
